function initNtfStates($stateProvider) {

	$stateProvider.state('home.notificationList', {
		url : "/notification/list",
		templateUrl : "views/ntf/notification.list.html",
		controller: "notificationListCtrl",
		resolve: {
			isFromList: function(){
				return true;
			}
		},
		data : {
			permissions : {
				only :  ROLE_TYPE.codes()
			}
		}
	});
}